import { COLORS_TO_BE_REVIEWED } from "components-redesign/styles/colors";
import { format } from "date-fns";
import { ChangeHistoryRow } from "../types";

export const TimeAndDateCell = ({ row }: { row: ChangeHistoryRow }) => (
  <div>
    <div style={{ fontWeight: 500 }}>
      {format(row.timestamp, "dd MMM yyyy")}
    </div>
    <div style={{ fontSize: "12px", color: COLORS_TO_BE_REVIEWED.anotherLightGray }}>
      {format(row.timestamp, "HH:mm")} UTC
    </div>
  </div>
);
